import React from 'react';

/**
 * パネル数分のセグメント。未選択は細線、選択中は太い角丸バー。
 * 選択が変わったときに細いラインがぷわっと太くなるアニメーション。
 * 製品・料金のモバイルカルーセル用。
 */
const CarouselIndicator = ({ count, activeIndex, className = '' }) => {
  if (count < 1) return null;

  return (
    <div
      className={`hub-carousel-indicator ${className}`.trim()}
      role="tablist"
      aria-label="スライドインジケーター"
    >
      <div className="hub-carousel-indicator-track">
        {Array.from({ length: count }).map((_, i) => (
          <div
            key={i}
            className={`hub-carousel-indicator-segment ${i === activeIndex ? 'active' : ''}`}
            role="tab"
            aria-selected={i === activeIndex}
            aria-label={`スライド ${i + 1} / ${count}`}
          />
        ))}
      </div>
    </div>
  );
};

export default CarouselIndicator;
